import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GenerateCompetitiveListExcelMutationResponse, GenerateCompetitiveListExcelQueryParams } from "../../types/GenerateCompetitiveListExcel";

/**
     * @link /api/purchase-tenders/private/v1/tender/do_generate-competitive-list
     */
export async function generateCompetitiveListExcel (params: GenerateCompetitiveListExcelQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GenerateCompetitiveListExcelMutationResponse>["data"]> {
    const { data: resData } = await client<GenerateCompetitiveListExcelMutationResponse>({
        method: "post",
        url: `/api/purchase-tenders/private/v1/tender/do_generate-competitive-list`,
        params,
        ...options
    });
    
    return resData;
};